import clsx from 'clsx';
import React, { useMemo } from 'react';
import { CalendarViewMode } from '../../../../types/calendar-view';

type DateCardProps = Readonly<{
  date?: Date;
  isSelected?: boolean;
  jobCount?: number | null;
  onClick?: (date: Date) => void;
  type: CalendarViewMode;
}>;

export default function DateCard({ date, isSelected, onClick, jobCount, type }: DateCardProps) {
  const topDateString = useMemo(() => {
    if (type === 'Weekly') {
      return date.toLocaleDateString('en-GB', { weekday: 'short', timeZone: 'UTC' });
    }
    return date.getUTCFullYear();
  }, [date, type]);

  const bottomDateString = useMemo(() => {
    if (type === 'Weekly') {
      return date.getUTCDate();
    }
    return date.toLocaleDateString('en-GB', { month: 'short', timeZone: 'UTC' });
  }, [date, type]);

  if (!date) return null;

  return (
    <button
      className={clsx(
        'date-card',
        { 'date-card--selected': isSelected },
        { 'date-card--disabled': jobCount === 0 && type === 'Weekly' }
      )}
      onClick={() => onClick(date)}
      type="button"
      aria-label={`Select date ${topDateString} ${bottomDateString}`}
    >
      <p className="date-card__day">{topDateString}</p>
      <p className="date-card__date">{bottomDateString}</p>
      {type === 'Weekly' && jobCount !== null ? (
        <p className="date-card__chip">{jobCount > 0 ? jobCount : '-'}</p>
      ) : null}
    </button>
  );
}
